import { useEffect } from "react";

import { PricingContentContextProvider } from "@/components/wpl/pricing/src/pricing-content-context";
import { NonProfitPricingPageTemplate } from "@/templates/non-profit-pricing-page/src";
import { checkFeatureFlagGate, featureFlags } from "@/utils/feature-flags";
import { PricingContent } from "@/utils/pricing-queries/get-pricing-content-gql.ts";

import { AppPricingData } from "../../../../contentful";
import { UserLocale } from "../../../../utils/useGeoCurrency";

import { getPricingTitleInternal } from "./feature-gates.ts";

export type NonProfitPricingPageProps = {
    pricing?: AppPricingData;
    countryCode?: UserLocale;
    pricingContent?: PricingContent;
};
export const NonProfitPricingPage = ({
    pricing,
    countryCode,
    pricingContent
}: NonProfitPricingPageProps) => {
    useEffect(() => {
        checkFeatureFlagGate(featureFlags.cpapiwdPricingAll);
    }, []);

    return (
        <PricingContentContextProvider
            productId="nonprofit"
            pricingTitleInternal={getPricingTitleInternal()}
            pricingContent={pricingContent}
        >
            <div data-testid="non-profit-pricing">
                <NonProfitPricingPageTemplate
                    pricing={pricing}
                    countryCode={countryCode}
                />
            </div>
        </PricingContentContextProvider>
    );
};
